import { render, staticRenderFns } from "./BannersDonasi.vue?vue&type=template&id=0b552b46"
import script from "./BannersDonasi.vue?vue&type=script&lang=js"
export * from "./BannersDonasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports